import { CustomAction } from 'model/state';
import {
  FETCH_DASHBOARD_ALERTS, FETCH_DASHBOARD_ALERTS_ERROR, FETCH_DASHBOARD_ALERTS_SUCCESS, FETCH_DASHBOARD_METRICS,
  FETCH_DASHBOARD_METRICS_ERROR, FETCH_DASHBOARD_METRICS_SUCCESS, UPDATE_DASHBOARD_ALERTS
} from 'constants/ActionTypes';
import { DeviceMetrics, Location } from 'model';

/**
 * Payload
 */
export interface DashboardPayload {
  userId?:    string;
  metrics?:   DeviceMetrics;
  locations?: Location[];
}

/**
 * Actions
 */
export const fetchDashboardMetrics = (userId: string): CustomAction<DashboardPayload> => {
  return {
    type: FETCH_DASHBOARD_METRICS,
    payload: { userId }
  };
};

export const fetchDashboardMetricsSuccess = (metrics: DeviceMetrics): CustomAction<DashboardPayload> => {
  return {
    type: FETCH_DASHBOARD_METRICS_SUCCESS,
    payload: { metrics }
  };
};

export const fetchDashboardMetricsError = (): CustomAction<DashboardPayload> => {
  return {
    type: FETCH_DASHBOARD_METRICS_ERROR,
  };
};

export const fetchDashboardAlerts = (userId: string): CustomAction<DashboardPayload> => {
  return {
    type: FETCH_DASHBOARD_ALERTS,
    payload: { userId }
  };
};

export const fetchDashboardAlertsSuccess = (): CustomAction<DashboardPayload> => {
  return {
    type: FETCH_DASHBOARD_ALERTS_SUCCESS,
  };
};

export const updateDashboardAlerts = (locations: Location[]): CustomAction<DashboardPayload> => {
  return {
    type: UPDATE_DASHBOARD_ALERTS,
    payload: { locations }
  };
};

export const fetchDashboardAlertsError = (): CustomAction<DashboardPayload> => {
  return {
    type: FETCH_DASHBOARD_ALERTS_ERROR,
  };
};